export const OPTION_SHAPE_NAMES = ["sun", "moon", "star", "heart"] as const;

export type OptionShapeName = (typeof OPTION_SHAPE_NAMES)[number];

/** SVG paths drawn in a 24x24 viewBox, filled with currentColor. */
const SHAPE_PATHS: Record<OptionShapeName, string> = {
  sun:
    "M12 6.5a5.5 5.5 0 1 1 0 11 5.5 5.5 0 0 1 0-11Zm0-5 1.8 3.2H10.2L12 1.5Zm0 21-1.8-3.2h3.6L12 22.5Zm10.5-10.5-3.2 1.8v-3.6l3.2 1.8Zm-21 0 3.2-1.8v3.6L1.5 12Zm17.92-7.42-1 3.54-2.54-2.54 3.54-1Zm-14.84 14.84 1-3.54 2.54 2.54-3.54 1Zm14.84 0-3.54-1 2.54-2.54 1 3.54ZM4.58 4.58l3.54 1-2.54 2.54-1-3.54Z",
  moon:
    "M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5a8.5 8.5 0 1 0 11 11Z",
  star:
    "M12 1.8l3.1 6.3 6.9 1-5 4.9 1.2 6.9-6.2-3.3-6.2 3.3 1.2-6.9-5-4.9 6.9-1L12 1.8Z",
  heart:
    "M12 21.2 4.3 13.4a5.3 5.3 0 0 1 0-7.5 5.2 5.2 0 0 1 7.4 0l.3.3.3-.3a5.2 5.2 0 0 1 7.4 0 5.3 5.3 0 0 1 0 7.5L12 21.2Z",
};

export interface OptionShapeProps {
  /** Answer option position; maps to the shape the same way colors map. */
  index: number;
  size?: number;
}

/**
 * Distinct shape per answer position so options are never color-only,
 * as required for color-blind players. Rendered in currentColor on the
 * option's colored background.
 */
export function OptionShape({ index, size = 22 }: OptionShapeProps) {
  const name = OPTION_SHAPE_NAMES[index % OPTION_SHAPE_NAMES.length] ?? "sun";
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
      data-shape={name}
    >
      <path d={SHAPE_PATHS[name]} />
    </svg>
  );
}
